/**
 * If you are not familiar with React Navigation, refer to the "Fundamentals" guide:
 * https://reactnavigation.org/docs/getting-started
 *
 */
import { FontAwesome } from "@expo/vector-icons";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import {
  NavigationContainer,
  DefaultTheme,
  DarkTheme,
} from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import * as React from "react";
import { ColorSchemeName } from "react-native";

import Colors from "../constants/colors";
import useColorScheme from "../hooks/useColorScheme";
import ModalScreen from "../screens/ModalScreen";
import NotFoundScreen from "../screens/NotFoundScreen";
import SyllabusScreen from "../screens/SyllabusScreen";
import VideosScreen from "../screens/VideosScreen";
import MovesScreen from "../screens/MovesScreen";
import FamiliesScreen from "../screens/FamiliesScreen";
import ViewSyllabiScreen from "../screens/ViewSyllabiScreen";
import { RootStackParamList, RootTabParamList } from "../types";
import LinkingConfiguration from "./LinkingConfiguration";
import ClazzesScreen from "../clazzes/ClazzesScreen";

/**
 * A bottom tab navigator displays tab buttons on the bottom of the display to switch screens.
 * https://reactnavigation.org/docs/bottom-tab-navigator
 */
const BottomTab = createBottomTabNavigator<RootTabParamList>();

function BottomTabNavigator() {
  const colorScheme = useColorScheme();

  return (
    <BottomTab.Navigator
      initialRouteName="Classes"
      screenOptions={{
        tabBarActiveTintColor: Colors[colorScheme].tint,
        tabBarStyle: {
          display: "none",
        },
        headerShown: false,
      }}
    >
      <BottomTab.Screen name="Classes" component={ClazzesScreen} />

      <BottomTab.Screen name="Moves" component={MovesScreen} />

      <BottomTab.Screen name="Videos" component={VideosScreen} />

      {/* <BottomTab.Screen name="Families" component={FamiliesScreen} /> */}
      {/* <BottomTab.Screen name="Syllabi" component={SyllabusScreen} /> */}
      {/* <BottomTab.Screen name="ViewSyllabi" component={ViewSyllabiScreen} /> */}
    </BottomTab.Navigator>
  );
}

export default BottomTabNavigator;
